import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { CALL_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { getAuthRecordingFileUrlRpc } from 'recording-review-components-lib/__generated__/chirp/com/hubspot/zoom/integration/chirp/rpc/RecordingRpc';
import { AUDIO } from '../../types/CallMediaTypes';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});
export const getZoomRecordingFile = ({
  engagementId,
  externalAccountId,
  mediaType = AUDIO
}) => {
  return chirpClient.call(getAuthRecordingFileUrlRpc, {
    request: {
      crmObjectId: typeof engagementId === 'string' ? parseInt(engagementId, 10) : engagementId,
      crmObjectTypeId: CALL_TYPE_ID,
      fileType: mediaType !== null && mediaType !== void 0 ? mediaType : AUDIO,
      accountId: externalAccountId
    }
  }).then(response => response.authenticatedUrl);
};